import { Icon_Facility } from "@/types/qr";

export function resolveInitialFacilities(
  previewFacilities?: Icon_Facility[]
): Icon_Facility[] | undefined {
  return previewFacilities && previewFacilities.length > 0 ? previewFacilities : undefined;
}

export function hasInitialFacilities(previewFacilities?: Icon_Facility[]): boolean {
  const resolvedFacilities = resolveInitialFacilities(previewFacilities);
  return Boolean(resolvedFacilities && resolvedFacilities.length > 0);
}
